import { useEffect, useState } from "react";
import api from "./api/api";
import functions from "../functions/functions";

function CustomerCreditPopup({ customer, onClose, onRefresh }) {
	const [transactions, setTransactions] = useState([]);
	const [loading, setLoading] = useState(true);
	const [showForm, setShowForm] = useState(false);
	const [formMode, setFormMode] = useState("carica");
	const [description, setDescription] = useState("");
	const [amount, setAmount] = useState("");
	const [orderId, setOrderId] = useState("");
	const [saving, setSaving] = useState(false);

	const balance = transactions.reduce((sum, t) => sum + parseFloat(t.price || 0), 0);
	const initials =
		((customer.surname || "")[0] || "").toUpperCase() +
		((customer.name || "")[0] || "").toUpperCase();

	useEffect(() => {
		loadTransactions();
	}, []);

	async function loadTransactions() {
		setLoading(true);
		const res = await api.postProtected("/credits_transactions/list/", {
			src: [{ name: "customer_id", value: customer.id, compare: "equal" }],
			orderby: "date_insert",
		});
		setLoading(false);
		if (res?.rows) setTransactions(res.rows);
	}

	async function handleDelete(id) {
		if (!window.confirm("Eliminare questa transazione?")) return;
		await api.postProtected("/credits_transactions/delete/" + id + "/");
		loadTransactions();
		if (onRefresh) onRefresh();
	}

	async function handleSave(e) {
		e.preventDefault();
		if (!description.trim() || !amount) return;
		setSaving(true);
		const price = formMode === "carica" ? parseFloat(amount) : -parseFloat(amount);
		await api.postProtected("/credits_transactions/add/", {
			customer_id: customer.id,
			description: description.trim(),
			price,
			order_id: orderId || null,
		});
		setSaving(false);
		setShowForm(false);
		setDescription("");
		setAmount("");
		setOrderId("");
		loadTransactions();
		if (onRefresh) onRefresh();
	}

	return (
		<div className="ctp-wrap">
			<div className="ctp-header">
				<div className="ctp-avatar">{initials}</div>
				<div className="ctp-info">
					<div className="ctp-name">
						{customer.name} {customer.surname}
					</div>
					<div className="ctp-phone">
						{customer.area_code}
						{customer.mobile}
					</div>
				</div>
				<div className="ctp-balance">
					<div className="ctp-balance-label">SALDO</div>
					<div className="ctp-balance-value">{functions.formatter.format(balance)}</div>
				</div>
			</div>

			{!showForm ? (
				<>
					<div className="ctp-list-header">
						<div className="ctp-list-title">Storico transazioni credito</div>
						<button className="ctp-insert-btn" onClick={() => setShowForm(true)}>
							+ Inserisci
						</button>
					</div>

					{loading && <div className="ctp-empty">Caricamento...</div>}
					{!loading && transactions.length === 0 && (
						<div className="ctp-empty">Nessuna transazione</div>
					)}
					{!loading && transactions.length > 0 && (
						<div className="ctp-table-wrap">
							<table className="ctp-table">
								<thead>
									<tr>
										<th>DATA</th>
										<th>DESCRIZIONE</th>
										<th>ORDINE</th>
										<th>IMPORTO</th>
										<th></th>
									</tr>
								</thead>
								<tbody>
									{transactions.map((t) => (
										<tr key={t.id}>
											<td className="ctp-td-date">{t.date_insert}</td>
											<td>{t.description}</td>
											<td>{t.order_id || "—"}</td>
											<td
												className={
													"ctp-td-amount " +
													(parseFloat(t.price) >= 0 ? "ctp-positive" : "ctp-negative")
												}
											>
												{parseFloat(t.price) >= 0 ? "+ " : ""}
												{functions.formatter.format(parseFloat(t.price))}
											</td>
											<td>
												<button
													className="ctp-delete-btn"
													onClick={() => handleDelete(t.id)}
													title="Elimina"
												>
													🗑
												</button>
											</td>
										</tr>
									))}
								</tbody>
							</table>
						</div>
					)}
				</>
			) : (
				<form className="ctp-form" onSubmit={handleSave}>
					<div className="ctp-form-tabs">
						<button
							type="button"
							className={"ctp-tab " + (formMode === "carica" ? "ctp-tab-active" : "")}
							onClick={() => setFormMode("carica")}
						>
							+ Carica credito
						</button>
						<button
							type="button"
							className={"ctp-tab " + (formMode === "scarica" ? "ctp-tab-active" : "")}
							onClick={() => setFormMode("scarica")}
						>
							% Scarica credito
						</button>
					</div>

					<div className="ctp-form-group">
						<label>Descrizione*</label>
						<input
							type="text"
							placeholder="es. Cash Back Ordine 2945, Ricarica, Rimborso..."
							value={description}
							onChange={(e) => setDescription(e.target.value)}
							required
							autoFocus
						/>
					</div>

					<div className="ctp-form-row">
						<div className="ctp-form-group">
							<label>Importo*</label>
							<div className="ctp-input-currency">
								<input
									type="number"
									min="0.01"
									step="0.01"
									placeholder="0,00"
									value={amount}
									onChange={(e) => setAmount(e.target.value)}
									required
								/>
								<span className="ctp-currency-symbol">€</span>
							</div>
						</div>
						<div className="ctp-form-group">
							<label>Ordine</label>
							<input
								type="text"
								placeholder="N° ordine (facoltativo)"
								value={orderId}
								onChange={(e) => setOrderId(e.target.value)}
							/>
						</div>
					</div>

					<div className="ctp-form-actions">
						<button
							type="button"
							className="ctp-btn-cancel"
							onClick={() => {
								setShowForm(false);
								setDescription("");
								setAmount("");
								setOrderId("");
							}}
						>
							Annulla
						</button>
						<button type="submit" className="ctp-btn-save" disabled={saving}>
							Salva
						</button>
					</div>
				</form>
			)}
		</div>
	);
}

export default CustomerCreditPopup;
